import { render, staticRenderFns } from "./WineList.vue?vue&type=template&id=6ed41066&scoped=true&"
import script from "./WineList.vue?vue&type=script&lang=js&"
export * from "./WineList.vue?vue&type=script&lang=js&"
import style0 from "./WineList.vue?vue&type=style&index=0&id=6ed41066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed41066",
  null
  
)

export default component.exports